import React from "react";
import { Box, Stack } from "@mui/material";
import { FacebookIcon, InstagramIcon, LinkedInIcon, SwedbankLogoIcon, TwitterIcon, YoutubeIcon } from "assets/icons";

export const Footer = () => {
  const config = [
    {
      icon: <TwitterIcon />,
      link: "https://twitter.com/swedbank_lt",
    },
    {
      icon: <FacebookIcon />,
      link: "https://www.facebook.com/SwedbankLietuvoje/",
    },
    {
      icon: <InstagramIcon />,
      link: "https://www.instagram.com/swedbanklietuvoje/",
    },
    {
      icon: <YoutubeIcon />,
      link: "https://www.youtube.com/channel/UCXDqabvs7saIBFn2rRoMhyA",
    },
    {
      icon: <LinkedInIcon />,
      link: "https://www.linkedin.com/company/swedbanklietuvoje",
    },
  ];
  return (
    <Box
      sx={{
        backgroundColor: (theme) => theme.palette.background2.main,
        mt: "auto",
        py: "1rem",
        px: { xs: "0.5rem", sm: "1rem" },
      }}
    >
      <Stack direction="row" justifyContent="space-between">
        <SwedbankLogoIcon />

        <Stack direction="row" alignItems="center" spacing={1} mr="4rem">
          {config.map(({ icon, link }) => (
            <a href={link} target="_blank" rel="noreferrer" key={link}>
              {icon}
            </a>
          ))}
        </Stack>
      </Stack>
    </Box>
  );
};
